export default __webpack_public_path__ + "static/media/Chamber-logo.6162d94f.png";